// removed by extract-text-webpack-plugin
module.exports = {"footerSegment":"mobileFooter__footerSegment--2ucJ7","footerLeftLabel":"mobileFooter__footerLeftLabel--15Pw1","footerLeftLabelText":"mobileFooter__footerLeftLabelText--3gbdN","footerLinkText":"mobileFooter__footerLinkText--NzG6Q","footerBlurbText":"mobileFooter__footerBlurbText--23pZd","footerLinksColumn":"mobileFooter__footerLinksColumn--2jj-y","enterEmailInput":"mobileFooter__enterEmailInput--ICgH1","signUpButton":"mobileFooter__signUpButton--3oCuG","icon":"mobileFooter__icon--1_d5C","row":"mobileFooter__row--3nemU","column":"mobileFooter__column--1Gh4J"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Footer/MobileFooter/mobileFooter.css
// module id = HT+2
// module chunks = 1